var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownButton = function SvgChevronDownButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C3DFA",
    d: "M17.75 9.247A.86.86 0 0 0 17.143 9a.88.88 0 0 0-.608.247l-3.925 3.831a.86.86 0 0 1-.609.248.88.88 0 0 1-.608-.248l-3.926-3.83A.86.86 0 0 0 6.858 9a.88.88 0 0 0-.609.247.826.826 0 0 0 0 1.18l3.934 3.84c.482.47 1.136.733 1.817.733s1.335-.264 1.817-.734l3.934-3.84a.826.826 0 0 0 0-1.179"
  })));
};
export default SvgChevronDownButton;